import { Badge } from "@/components/ui/badge";
import type { SupplierInvoiceStatus } from "@shared/finance/supplierInvoices";

const STATUS_LABELS: Record<SupplierInvoiceStatus, string> = {
  draft: "Borrador",
  received: "Recibida",
  pending_review: "Pendiente revisión",
  approved: "Aprobada",
  scheduled_for_payment: "Programada para pago",
  partially_paid: "Parcialmente pagada",
  paid: "Pagada",
  cancelled: "Cancelada",
};

const STATUS_CLASSES: Record<SupplierInvoiceStatus, string> = {
  draft: "bg-gray-100 text-gray-800 border-gray-200",
  received: "bg-blue-100 text-blue-800 border-blue-200",
  pending_review: "bg-yellow-100 text-yellow-800 border-yellow-200",
  approved: "bg-green-100 text-green-800 border-green-200",
  scheduled_for_payment: "bg-purple-100 text-purple-800 border-purple-200",
  partially_paid: "bg-orange-100 text-orange-800 border-orange-200",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-200",
  cancelled: "bg-red-100 text-red-800 border-red-200",
};

export function SupplierInvoiceStatusBadge({ status }: { status: SupplierInvoiceStatus | string }) {
  const label = STATUS_LABELS[status as SupplierInvoiceStatus] ?? status;
  const className = STATUS_CLASSES[status as SupplierInvoiceStatus] ?? "bg-gray-100 text-gray-800";
  return (
    <Badge className={className} variant="outline">
      {label}
    </Badge>
  );
}
